module.exports = __webpack_public_path__ + "static/media/hala_arabic_gulf.eb09e68c.mp3";